import React from 'react'
import Select from 'react-select';

function SearchDropdown({className, options, placeholder, defaultValue, value, disabled, onChange}){
    return <Select
        {...(value ? {value} : {})}
        isDisabled={disabled}
        onChange={onChange}
        className={`${className} select-dropdown`}
        classNames={{
            input: (state) => 'select-dropdown',
            option: (state) => state.isFocused ? 'select-dropdown-option-focused' : 'select-dropdown-option'
        }}
        options={options}
        defaultValue={defaultValue}
        isSearchable={true}
        placeholder={placeholder}
    />
}

SearchDropdown.defaultProps = {
    disabled: false,
    options: [],
    className: "",
    defaultValue: "",
    value: null,
    placeholder: "",
    onChange: () => {}
}

export default SearchDropdown